export { default } from './SmallHeader';
